module.exports = __webpack_public_path__ + "static/img/51.8bca148.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/51.png
// module id = HQu7
// module chunks = 0